import { render, staticRenderFns } from "./product_open.vue?vue&type=template&id=814dfa3c&scoped=true"
import script from "./product_open.vue?vue&type=script&lang=js"
export * from "./product_open.vue?vue&type=script&lang=js"
import style0 from "./product_open.vue?vue&type=style&index=0&id=814dfa3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814dfa3c",
  null
  
)

export default component.exports